<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="page_links">
					当前位置：
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item :to="{ path: '/uc_goods' }">我的商品</el-breadcrumb-item>
						<el-breadcrumb-item>编辑</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="connect_main">
					<p class="fb">基础信息</p>
					<div class="basic_info">
						<div class="input_box title_input">
							<p class="title need">商品标题</p>
							<div class="el_input">
								<el-input 
									placeholder="请输入商品标题" 
									maxlength="60" 
									show-word-limit>
								</el-input>
							</div>
						</div>
						<p class="tips1">标题不规范会引起商品下架，影响您的正常销售，请点击学习 <a href="#" class="red">商品发布规范</a> 认真填写</p>
						<p class="tips2"><span>重要属性 </span>错误填写属性，会引起商品下架，请认真准确填写。若遇到属性、属性值不能满足您的发布需求，请<a href="#" class="red">点击反馈</a></p>
						<div class="attributes">
							<div class="input_box">
								<p class="title">货号</p>
								<div class="el_input">
									<el-input placeholder="请输入货号" ></el-input>
								</div>
							</div>
							<div class="input_box">
								<p class="title need">商品标题</p>
								<div class="el_input">
									<el-select v-model="value" placeholder="请选择">
										<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="input_box">
								<p class="title need">裙长</p>
								<div class="el_input">
									<el-select v-model="value" placeholder="请选择">
										<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="input_box">
								<p class="title need">腰型</p>
								<div class="el_input">
									<el-select v-model="value" placeholder="请选择">
										<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="input_box">
								<p class="title need">裙型</p>
								<div class="el_input">
									<el-select v-model="value" placeholder="请选择">
										<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="input_box">
								<p class="title need">廓形</p>
								<div class="el_input">
									<el-select v-model="value" placeholder="请选择">
										<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="input_box">
								<p class="title need">风格</p>
								<div class="el_input">
									<el-select v-model="value" placeholder="请选择">
										<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="input_box">
								<p class="title need">面料材质</p>
								<div class="el_input">
									<el-select v-model="value" placeholder="请选择">
										<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="input_box">
								<p class="title need">廓形</p>
								<div class="el_input">
									<el-select v-model="value" placeholder="请选择">
										<el-option
											v-for="item in options"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
							</div>
						</div>
					</div>
					<div class="picture_info">
						<p class="fb">图文信息</p>
						<div class="input_box">
							<p class="title need">主图</p>
							<div class="upload_wrap">
								<ul class="el-upload-list el-upload-list--picture-card">
									<draggable v-model="fileDetailList">
										<li v-for="(item, index) in fileDetailList" :key="index" class="el-upload-list__item is-success animated up_box">
											<img :src="item.url" alt="" class="el-upload-list__item-thumbnail ">
											<i class="el-icon-close"></i>
											<div class="actions_box">
												<div class="tab" @click="handlePictureCardPreview(item)">
													<i class="iconfont icon-eyes"></i>
													<p>预览</p>
												</div>
												<div class="tab" @click="handleRemove(item)">
													<i class="iconfont icon-delete"></i>
													<p>删除</p>
												</div>
											</div>
								              </li>
									</draggable>
								</ul>
								<el-upload
								              class="uoloadSty"
								              ref="uploadDetail"
								              :multiple="true"
								              action="#"
								              list-type="picture-card"
								              :file-list="fileDetailList"
								              :show-file-list="false"
								              :auto-upload="false"
									      :on-change="handleChangeFileDetail"
								              :on-remove="handleRemove"
								              :on-preview="handlePictureCardPreview">
								          <i class="el-icon-plus"></i>
								</el-upload>
								<el-dialog :visible.sync="dialogVisible">
									<img width="100%" :src="dialogImageUrl" alt="">
								</el-dialog>
							</div>
						</div>
						<p class="tips1">仅支持png，jpg，jpeg格式，宽高比例为1:1（至少600*600px），大小5M内，可拖拽调整主图顺序 <a href="#" class="red">查看图示</a></p>
						<div class="input_box">
							<p class="title need">主图视频</p>
							<div class="video_wrap">
								<div :class="isUploadVideo?'video_con add_hide':'video_con'">
									<el-upload
										action="#"
										list-type="picture-card"
										:auto-upload="false"
										:on-change="handleVideoChange"
										:on-preview="handleVideoPreview">
											<i slot="default" class="el-icon-plus"></i>
											<div slot="file" slot-scope="{file}" class="video_box">
												<video :src="file.url"></video>
												<div class="actions_box">
													<div class="tab" @click="handleVideoPreview(file)">
														<i class="iconfont icon-eyes"></i>
														<p>预览</p>
													</div>
													<div class="tab" @click="handleVideoRemove(file)">
														<i class="iconfont icon-delete"></i>
														<p>删除</p>
													</div>
												</div>
											</div>
									</el-upload>
									<el-dialog :visible.sync="dialogVideoVisible">
										<video :src="dialogVideoUrl" controls autoplay class="video_play"></video>
									</el-dialog>
								</div>
							</div>
						</div>
					</div>
					
					
				</div>
				
			</div>
		</div>
		<div class="fixed_bottom">
			<div class="inner">
				<p class="btn">发布商品</p>
				<p class="btn">保存草稿</p>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import myHead from '../../components/myHead/myhead';
import draggable from 'vuedraggable'
import { Col } from 'element-ui';
export default {
	name: "goodsConnect",
	data() {
		return {
			options: [
				{value: '选项1',label: '黄金糕'}, 
				{value: '选项2',label: '双皮奶'}, 
				{value: '选项3',label: '蚵仔煎'}, 
				{value: '选项4',label: '龙须面'}, 
				{value: '选项5',label: '北京烤鸭'},
			],
			value: '',
			dialogImageUrl: '',
			dialogVisible: false,
			fileDetailList:[],
			dialogVideoVisible: false,
			dialogVideoUrl:'',
			isUploadVideo: false,
		}
	},
	components:{
		myHead,draggable
	},
	created(){
		
	},
	methods: {
		handleChangeFileDetail(value){//上传图片链接加入到图片数组中
			this.fileDetailList.push(value)
			console.log(value,this.fileDetailList)
		},
		handleRemove(file) {
			console.log(file);
		},
		handlePictureCardPreview(file) {
			console.log(file);
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		handleVideoChange(res){
			console.log('zz',res)
			this.isUploadVideo = true
		},
		handleVideoRemove(file) {
			console.log(file);
			this.isUploadVideo = false
		},
		handleVideoPreview(file) {
			console.log(file);
			this.dialogVideoUrl = file.url;
			this.dialogVideoVisible = true;
		},
	}
}
</script>

<style scoped>
.connect_main{margin-top: 30px;width: 100%;height: auto;box-sizing: border-box;padding: 30px 40px;background: #fff;line-height: 1;}
.title_input{width: 820px;line-height: 1;}
.title_input .input_box .title{color: #333;}
.basic_info .tips1{font-size: 12px;color: #999999;margin-top: 10px;}
.basic_info .tips2{font-size: 12px;color: #999999;margin-top: 25px;}
.basic_info .tips2 span{font-size: 14px;color: #333;margin-right: 15px;}
.attributes{width: 900px;display: flex;flex-wrap: wrap;}
.attributes .input_box{margin-right: 15px;width: 290px;}
.attributes .input_box:nth-child(3n){margin-right: 0;}
.input_box{margin-top: 20px;}
.input_box .title{font-size: 14px;color: #666;}
.input_box .title.need::before{content: '*';color: var(--red);margin-right: 6px;}
.input_box .el_input{margin-top: 10px;}

.picture_info{margin-top: 40px;}
.picture_info .upload_wrap{margin-top: 10px;display: flex;flex-wrap: wrap;}
.picture_info .up_box{position: relative;}
.picture_info .up_box:hover{cursor: grab;}
.picture_info .up_box:active{cursor: grabbing;}
.picture_info .up_box::before{content: '';width: 100%;height: 100%;background: rgba(0, 0, 0, .5);position: absolute;top: 0;left: 0;z-index: 2;visibility: hidden;opacity: 0;transition: all .3s ease-in-out;}
.picture_info .up_box:hover::before{visibility: visible;opacity: 1;}
.picture_info .up_box .actions_box{width: 100px;height: 50px;background: #fff;border-radius: 4px;position: absolute;top: -54px;left: 50%;transform: translate(-50%,20%);filter: drop-shadow(0 0 3px #ddd);z-index: 2;display: flex;justify-content: space-around;align-items: center;visibility: hidden;opacity: 0;transition: all .3s ease-in-out;}
.picture_info .up_box:hover .actions_box{transform: translate(-50%,0);visibility: visible;opacity: 1;}
.picture_info .up_box .actions_box::after{content: '';width: 10px;height: 10px;background: #fff;position: absolute;bottom: -4px;left: 50%;transform: translateX(-50%) rotate(45deg);}
.picture_info .up_box .actions_box .tab{width: 40px;height: 40px;border-radius: 4px;text-align: center;line-height: 1;color: #999999;cursor: pointer;display: flex;flex-direction: column;justify-content: center;align-items: center;}
.picture_info .up_box .actions_box .tab:hover{background: #f9f9f9;}
.picture_info .up_box .actions_box .tab .iconfont{font-size: 14px;}
.picture_info .up_box .actions_box .tab p{font-size: 12px;margin-top: 4px;}
.picture_info .tips1{font-size: 12px;color: #999999;margin-top: 10px;}
.picture_info .video_wrap{margin-top: 25px;display: flex;}
.picture_info .video_wrap .video_con{width: 100px;height: 100px;}
.picture_info .video_wrap .video_con .video_box{width: 100%;height: 100%;display: flex;justify-content: space-between;align-items: center;overflow: hidden;}
.picture_info .video_wrap .video_con .video_box video{width: 100%;height: 100%;object-fit: cover;}
.video_play{width: 100%;height: 100%;object-fit: cover;}
.video_box .actions_box{width: 100px;height: 50px;background: #fff;border-radius: 4px;position: absolute;top: -54px;left: 50%;transform: translate(-50%,20%);filter: drop-shadow(0 0 3px #ddd);z-index: 2;display: flex;justify-content: space-around;align-items: center;visibility: hidden;opacity: 0;transition: all .3s ease-in-out;}
.video_box:hover .actions_box{transform: translate(-50%,0);visibility: visible;opacity: 1;}
.video_box .actions_box::after{content: '';width: 10px;height: 10px;background: #fff;position: absolute;bottom: -4px;left: 50%;transform: translateX(-50%) rotate(45deg);}
.video_box .actions_box .tab{width: 40px;height: 40px;border-radius: 4px;text-align: center;line-height: 1;color: #999999;cursor: pointer;display: flex;flex-direction: column;justify-content: center;align-items: center;}
.video_box .actions_box .tab:hover{background: #f9f9f9;}
.video_box .actions_box .tab .iconfont{font-size: 14px;}
.video_box .actions_box .tab p{font-size: 12px;margin-top: 4px;}












.fixed_bottom{width: 100%;height: 70px;}
.fixed_bottom .inner{width: 100%;height: 70px;background: #fff;box-shadow: 0px -1px 1px 0px #eeeeee;position: fixed;left: 0;bottom: 0;z-index: 99;display: flex;justify-content: center;align-items: center;}
.fixed_bottom .inner .btn{width: 90px;height: 32px;border-radius: 4px;display: flex;justify-content: center;align-items: center;margin: 0 10px;cursor: pointer;font-size: 12px;box-sizing: border-box;}
.fixed_bottom .inner .btn:nth-child(1){background: var(--red);color: #fff;}
.fixed_bottom .inner .btn:nth-child(2){border: 1px solid var(--red);color: var(--red);background: #fff;}
.red{color: var(--red) !important;cursor: pointer;}
.red:hover{text-decoration: underline;}
/* .goods_info{margin-top: 26px;display: flex;}
.goods_info .img_box{width: 48px;height: 48px;background: #eee;border-radius: 6px;overflow: hidden;}
.goods_info .con_box{flex: 1;width: 0;margin-left: 10px;font-size: 12px;}
.goods_info .con_box .name{line-height: 16px;}
.goods_info .con_box .id{color: #999999;margin-top: 8px;}
.table_wrap{margin-top: 30px;font-size: 12px;}
.get_config{color: var(--red);cursor: pointer;}
.get_config:hover{text-decoration: underline;}
.table_wrap .pingtai{width: 80px;margin: 0 auto;text-align: left;box-sizing: border-box;padding-left: 20px;}

.add_line{display: flex;justify-content: space-between;align-items: flex-end;margin: 30px 0 20px;}
.add_line .add_btn{width: 102px;height: 35px;box-sizing: border-box;border: 1px solid var(--red);border-radius: 4px;cursor: pointer;display: flex;justify-content: center;align-items: center;font-size: 14px;color: var(--red);}
.add_line .clear{font-size: 14px;color: #999999;display: flex;align-items: center;cursor: pointer;}
.add_line .clear .iconfont{font-size: 14px;margin-right: 8px}

.config_wrap .title_wrap{width: 100%;height: 50px;background: #f5f5f5;box-sizing: border-box;border: 1px solid #eee;display: flex;align-items: center;font-size: 14px;color: #999}
.config_wrap .title_wrap .t1{width: 320px;margin: 0 16px;}
.config_wrap .title_wrap .t2{width: 80px;text-align: center;}
.config_wrap .title_wrap .t3{width: 120px;margin: 0 30px 0 20px;text-align: center;}
.config_wrap .title_wrap .t4{flex: 1;width: 0;}
.config_wrap .content_wrap{margin-top: 20px;padding-bottom: 40px;border-bottom: 1px solid #eee;height: 220px;overflow-y: auto;overflow-x: hidden;font-size: 14px;}
.content_wrap .content_line{display: flex;align-items: flex-start;margin-top: 26px;}
.content_wrap .content_line:first-child{margin-top: 0;}
.content_line .b1{width: 320px;margin: 0 16px;line-height: 20px;box-sizing: border-box;padding-right: 50px;}
.content_line .b2{width: 80px;text-align: center;}
.content_line .b3{width: 120px;margin: 0 30px 0 20px;display: flex;justify-content: center;align-items: center;}
.content_line .b4{flex: 1;width: 0;display: flex;}
.content_line .b3 .t{margin-right: 10px;}

.btn_wrap{margin-top: 20px;display: flex;justify-content: flex-end;}
.btn_wrap .btn{width: 90px;height: 32px;border-radius: 4px;display: flex;justify-content: center;align-items: center;margin-left: 20px;cursor: pointer;font-size: 12px;box-sizing: border-box;}
.btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;}
.btn_wrap .btn:nth-child(2){border: 1px solid #ddd;color: #333333;}
 */

</style>
<style>
.page_links{line-height: 1;font-size: 14px;color: #999999;display: flex;margin-top: 25px;}
.page_links .el-breadcrumb__inner{font-weight: bold !important;color: #333 !important;}
.page_links .el-breadcrumb__inner.is-link{font-weight: initial !important;color: #999 !important;}
.page_links .el-breadcrumb__inner.is-link:hover{color: #f0423f !important;text-decoration: underline;}


.el_input .el-input__inner{height: 34px;line-height: 34px;}
.el_input .el-select{width: 100%;}
.el-upload-list--picture-card .el-upload-list__item{overflow: initial;width: 100px;height: 100px;margin: 0 14px 10px 0;border-radius: initial;}
.el-upload--picture-card{width: 100px;height: 100px;line-height: 98px;border-radius: initial;}
.video_con.add_hide .el-upload--picture-card{display: none !important;}

.table_wrap .el-table::before{display: none;}
.el-table .el-table_1_column_2 .cell .num{color: #999;}
.el-table th.el-table__cell{background: #fff6f7;border-bottom: none !important;color: #666666;padding: 12px 0;}
.el-table .el-table__cell{padding: 24px 0;}
.el-table .cell{padding: 0 20px;text-align: center;font-size: 12px;color: #333;}
.el-table .el-table_1_column_1 .cell{text-align: center;}
.el-table .el-table_1_column_2 .cell{padding: 0 10px;}
.el-table th.el-table_1_column_2 .cell{text-align: left;}
.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{border-bottom: none;}

.el-input-number__decrease:hover, .el-input-number__increase:hover ,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path ,.el-select-dropdown__item.selected{color: var(--red);}
.input_number .el-input__inner:hover ,.el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled), .el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) ,.el-input__inner:focus ,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner ,.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus ,.el-upload--picture-card:hover, .el-upload:focus{border-color: var(--red);}
</style>